import React from 'react'

import IconButtonMaterial from '@mui/material/IconButton'

/**
 * Button Icon
 * @param {object} props
 * @param {function} props.onClick
 * @param {React.Component} props.children
 * @param {string} [props.title]
 * @param {string} [props.className]
 * @param {'small'|'medium'|'large'} [props.size='small']
 * @param {string} [props.fontSize]
 */
const IconButton = (props) => {
  const {
    children, onClick = null, size = 'small', title = '', className = '',
    fontSize = ''
  } = props

  return (
    <IconButtonMaterial
      onClick={onClick}
      size={size}
      title={title}
      className={className}
      style={fontSize ? { fontSize } : null}
    >
      {children}
    </IconButtonMaterial>
  )
}

export default IconButton
